import { Input } from '@/common/components/Input.tsx'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useNavigate } from 'react-router-dom';
import { AppRoutePaths } from '@/routing/route_paths'
import { Label } from '@/shad/ui/label'
import { useSelector, useDispatch } from "react-redux"
import { RootState } from '@/storage/store'
import { setReimbursementAccountBankName } from '@/storage/applications/reimubrusementAccountSlice'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout'
import { SubmitButton } from '@/app/pages/family_application/student_details/shared/submit-button'
import { Button } from '@/app/common/components/Button'

const detailSchema = z
  .object({
    bank_name: z.string().min(1, 'bank_name_is_required'),
  })

type FormValues = z.infer<typeof detailSchema>

export const ReimbursementAccountBankName = () => {
  const { t: translate } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { currentAccount } = useSelector((state: RootState) => state.ReimbursementAccount)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(detailSchema),
    defaultValues: {
      bank_name: currentAccount?.bankName ?? "",
    }
  })

  const onSubmit: SubmitHandler<FormValues> = async (data:FormValues) => {
    dispatch(setReimbursementAccountBankName(data.bank_name))
    navigate(AppRoutePaths.reimbursements.accounts.link.detail)
  }

  const onBack = () => {
    navigate(-1)
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('whats_the_name_of_your_bank')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="w-80">
        <form
          id="form"
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-3"
        >
          <div className="my-10">
            <section
              className="flex flex-col mt-6 space-y-2"
              aria-labelledby="bank_name_label"
            >
              <Label
                id="bank_name_label"
                htmlFor="bank_name"
              >
                {translate('bank_name')}{' '}
                <span className="text-danger ml-1">*</span>
              </Label>
              <div className="relative mt-2 rounded-md shadow-sm">
                <Input
                  id="bank_name"
                  {...register('bank_name')}
                />
              </div>
              {errors.bank_name && (
                <p className="mt-1 text-sm text-red-600">
                  {translate(errors.bank_name.message ?? '')}
                </p>
              )}
            </section>
      
          </div>
        </form>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="justify-center">
      <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={onBack}
            className="px-10"
          >
            {translate('back')}
          </Button>
          {' '}          <SubmitButton
            form="form"
            status={'idle'}
            buttonTxt={translate('next')}
            className="px-10"
          />
        </div>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
